<template>
    <div class="row mt-2 mb-2 justify-content-md-center justfiy-content-left">
        <div class="col-sm-9 col-lg-10 pr-sm-0">
            <submission-card
                :id="id"
                :text="text"
                :status="status"
                :image_url="image_url"
                :submission_time="submission_time"
                :decision_time="decision_time"
                :scheduled_post_time="scheduled_post_time"
                :route_truth_details="route_truth_details"
                :filter_phrases="filter_phrases"
                :numbered="numbered"
                :header_text="header_text"
                :nsfw_probability="nsfw_probability"
                :instagram="instagram">
            </submission-card>
        </div>
        
        
        <div class="col-sm-3 col-md-2 px-3">
            <sub-buttons
                :id="id"
                v-on="$listeners">
            </sub-buttons>
        </div>
    </div>
</template>

<script>
import SubmissionCard from '../submissions/SubmissionCard'
import SubButtons from './SubButtons'

export default {
    name: "PostingListItem",

    components: {
        SubmissionCard,
        SubButtons
    },

    props: {
        id: {
            type: Number,
            required: true,
        },
        text: {
            type: String,
            required: true,
        },
        status: {
            type: String,
            required: true,
        },
        image_url: {
            type: String,
        },
        submission_time : {
            type: String,
            required: true,
        },
        decision_time : {
            type: String,
            required: true,
        },
        scheduled_post_time : {
            type: String,
        },
        route_truth_details: {
            type: String,
            required: true,
        },
        filter_phrases: {
            type: Array,
            default: () => [],
        },
        numbered: {
            type: Boolean,
            required: true
        },
        header_text: {
            type: String,
        },
        nsfw_probability: {
            type: Number
        },
        instagram: {
            type: Boolean
        }
    }
}
</script>